import './App.css';
import TestFrida from './TestFrida';

function App() {
  return (
<div className="App">
      

        <TestFrida> </TestFrida>
        
     
    </div>
  );
}

export default App;
